// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account-conatainer {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  padding: 13px;\n  margin-top: -100px;\n}", ""]);
// Exports
module.exports = exports;
